'use client';

import { FC, useActionState } from 'react';
import { Alert, Anchor, Button, Card, Checkbox, Flex, PasswordInput, Text, TextInput } from '@mantine/core';
import { SlArrowRight } from 'react-icons/sl';
import { AppPaths } from '@/configs/appPaths';
import { handleRegisterForm, RegistrationFormValues } from '@/app/register/actions';
import { CountryPicker } from '@/ui/countryPicker/CountryPicker';

interface Props {

}

const initialState = {
	error: '',
	message: '',
	values: {} as Partial<RegistrationFormValues>,
}

export const ClientRegister: FC<Props> = () => {
	const [state, formAction, pending] = useActionState(handleRegisterForm, initialState)

	return (
		<Card component={'form'} action={formAction}>
			{state.message && (
				<Alert
					color="green"
					mb="md"
					title="Sukces"
				>
					{state.message}
				</Alert>
			)}

			{state.error && (
				<Alert
					color="red"
					mb="md"
					title="Błąd"
				>
					{state.error}
				</Alert>
			)}

			<Flex gap={'md'} mb="md" direction={{ base: 'column', md: 'row' }} justify={'space-between'}>
				<TextInput
					required
					type="text"
					name="name"
					label="Imię"
					w={'100%'}
					defaultValue={state.values?.name}
				/>
				<TextInput
					required
					type="text"
					name="surname"
					label="Nazwisko"
					w={'100%'}
					defaultValue={state.values?.surname}
				/>
			</Flex>

			<TextInput
				required
				type="text"
				name="email"
				mb="md"
				label="Adres e-mail"
				defaultValue={state.values?.email}
			/>

			<Flex gap={'md'} mb="md" direction={{ base: 'column', md: 'row' }} justify={'space-between'}>
				<TextInput
					required
					type="text"
					name="companyName"
					label="Nazwa firmy"
					w={'70%'}
					defaultValue={state.values?.companyName}
				/>
				<CountryPicker
					label="Kraj"
					w={'30%'}
					name="country"
					pointer
					defaultValue={state.values?.country}
				/>
			</Flex>

			<Flex gap={'md'} mb="md" direction={{ base: 'column', md: 'row' }} justify={'space-between'}>
				<PasswordInput
					required
					name="password"
					label="Hasło"
					mb="md"
					w={'100%'}
				/>
				<PasswordInput
					required
					name="repassword"
					label="Powtórz hasło"
					mb="md"
					w={'100%'}
				/>
			</Flex>

			<Checkbox mb="md" label={"Akceptuję regulamin i politykę prywatności"} required/>
			<Checkbox mb="md" label={"Posiadam upoważnienie do stworzenia konta firmowego"} required/>

			<Button fullWidth mb="xl" loading={pending} type={'submit'}>
				<Flex gap="sm" align="center">
					<Text fw="bold">Zarejestruj się</Text>
					<SlArrowRight size={20} />
				</Flex>
			</Button>

			<Text mb="sm">
				Jeśli posiadasz już konto,{' '}
				<Anchor href={`/${AppPaths.LOGIN}`} underline="always">
					kliknij tutaj
				</Anchor>
				.
			</Text>
		</Card>
	);
}